import { useEffect, useState } from "react";
import { LuBadgePercent, LuTickets } from "react-icons/lu";
import { Edition } from "./edition";
import { TableLayout } from "../../layouts/table";
import { CollectionSummary } from "../../../../components/collectionTools";
import { DiscountList } from "./discountList";
import { discountState, getDiscountList } from "./discountListModel";
import "./style.css";
export { discountState } from "./discountListModel";
export const Discounts = () => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(timer);
  }, []);
  return (
    <section className="catalogsReference discountsReference">
      <TableLayout
        title="Descuentos"
        addText="Nuevo descuento"
        emptyTitle="Todavía no tienes descuentos"
        emptyDescription="Crea tu primer descuento para empezar a ofrecer promociones."
        edition={<Edition />}
        get={getDiscountList}
        idKey="discountId"
        identificator="discounts"
        renderSummary={(rows) => (
          <CollectionSummary
            items={[
              {
                label: "Descuentos activos",
                icon: <LuBadgePercent />,
                value: rows.filter(
                  (row) => discountState(row, now) === "active",
                ).length,
              },
              {
                label: "Usos este mes",
                icon: <LuTickets />,
                value: "—",
                detail: "No hay desglose mensual en este listado",
              },
            ]}
          />
        )}
        renderContent={(rows, onEdit) => (
          <DiscountList rows={rows} onEdit={onEdit} now={now} />
        )}
      />
    </section>
  );
};
